<template>
  <svg
    class="custom-icon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.6064 4.22214C23.3874 3.44109 23.3874 2.17476 22.6064 1.39371C21.8253 0.612662 20.559 0.612663 19.7779 1.39371L11.9998 9.17188L4.22158 1.39371C3.44053 0.61266 2.1742 0.61266 1.39316 1.39371C0.612108 2.17476 0.612106 3.44109 1.39316 4.22214L9.17133 12.0003L1.39315 19.7785C0.612106 20.5595 0.612106 21.8259 1.39315 22.6069C2.1742 23.388 3.44053 23.388 4.22158 22.6069L11.9998 14.8287L19.7779 22.6069C20.559 23.388 21.8253 23.388 22.6064 22.6069C23.3874 21.8259 23.3874 20.5595 22.6064 19.7785L14.8282 12.0003L22.6064 4.22214Z"
    />
  </svg>
</template>
